import type { ClientQuestion } from '@fixit/bozp-content';

/** Distinct chapterIds (in first-seen order) of the questions the worker got wrong. */
export function deriveWeakChapterIds(
  questions: ClientQuestion[],
  wrongQuestionIds: string[],
): string[] {
  const wrong = new Set(wrongQuestionIds);
  const out: string[] = [];
  for (const q of questions) {
    if (wrong.has(q.id) && q.chapterId && !out.includes(q.chapterId)) {
      out.push(q.chapterId);
    }
  }
  return out;
}
